/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartRequestSchema } from "./banquetCartRequestSchema.ts";
import { reserveSchema } from "./reserveSchema.ts";

export const orgUnitReserveItemsUpdatePathOrgUnitIdSchema = z.uuid();

export const orgUnitReserveItemsUpdatePathReserveIdSchema = z.uuid();

export const orgUnitReserveItemsUpdateStatus200Schema = reserveSchema;

export const orgUnitReserveItemsUpdateResponseSchema = orgUnitReserveItemsUpdateStatus200Schema;

export const orgUnitReserveItemsUpdateDataSchemaJson = banquetCartRequestSchema.describe(
	"Состав банкета в формате корзины заказа: тело для замены состава как есть.",
);

export const orgUnitReserveItemsUpdateDataSchemaXml = banquetCartRequestSchema.describe(
	"Состав банкета в формате корзины заказа: тело для замены состава как есть.",
);

export const orgUnitReserveItemsUpdateDataSchema = z.union([orgUnitReserveItemsUpdateDataSchemaJson, orgUnitReserveItemsUpdateDataSchemaXml]);
